`<template>
    <div>
        <v-row :class="isMobile == true ? 'no-pd' : ''">
            <v-col cols="12" md="4">
                <h1 class="mb-3 headline font-weight-light">
                    <router-link class="link-a" :to="'/OT'">
                        {{ "OT - " + data_main.paycode }}</router-link
                    >
                    / Approve
                </h1>

                <h1 class="mb-3 headline font-weight-light"></h1>
            </v-col>
            <v-spacer></v-spacer>

            <v-col
                cols="12"
                md="8"
                class="text-right"
                v-if="chk_calculate == true"
            >
                <v-btn
                    small
                    color="white"
                    class="primary--text"
                    rounded
                    v-if="data_main.approve_status != null"
                    @click="dialogLogOT = true"
                >
                    <v-icon left small>mdi-magnify</v-icon>
                    View Approve Log
                </v-btn>
                <v-progress-linear
                    v-if="chk_approve_2 == true"
                    color="orange accent-4"
                    indeterminate
                ></v-progress-linear>
                <v-btn
                    v-if="
                        func_chk_approve(chk_approve) == true &&
                            chk_approve_2 == false
                    "
                    class="ml-4 mr-2"
                    small
                    color="success"
                    @click="save_approve('approve')"
                    :disabled="checkboxs.length == 0"
                >
                    <v-icon small class="mr-1">mdi-content-save</v-icon>
                    {{ "Approve OT : " + checkboxs.length + " Case" }}</v-btn
                >
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    v-if="
                        func_chk_approve(chk_approve) == true &&
                            chk_approve_2 == false
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn small color="red" dark v-bind="attrs" v-on="on">
                            Not Approve
                        </v-btn>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-item>
                                <v-text-field
                                    small
                                    label="เหตุผลที่ไม่อนุมัติ..."
                                    v-model="form_save.remark"
                                ></v-text-field>
                            </v-list-item>
                        </v-list>

                        <v-card-actions>
                            <v-btn small text @click="close_approve()"
                                >Cancel</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                color="success"
                                :disabled="form_save.remark.length <= 0"
                                @click="save_approve('not approve')"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>

        <v-card :class="isMobile == true ? 'no-pd' : ''">
            <v-row style="background-color:#0c374e" class="mb-5">
                <v-col cols="12" v-if="chk_load == true">
                    <v-progress-linear
                        indeterminate
                        color="orange accent-4"
                    ></v-progress-linear>
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                    v-if="data_main.engineer && chk_load == false"
                >
                    <span style="color:#fffb00;font-weight: bold;">{{
                        data_main.engineer.engineer_name
                    }}</span>
                </v-col>

                <v-col
                    cols="12"
                    md="6"
                    v-if="chk_calculate == false && chk_load == false"
                    class="text-right"
                >
                    <v-btn
                        small
                        rounded
                        color="amber"
                        @click="calculate()"
                        :disabled="checkboxs.length == 0"
                    >
                        <v-icon class="mr-1">mdi-webhook</v-icon>
                        <span :class="checkboxs.length == 0 ? 'blue--text' : ''"
                            >calculate ot</span
                        >
                    </v-btn>
                </v-col>

                <v-col
                    cols="12"
                    md="6"
                    class="text-right"
                    v-if="chk_calculate == true && data_main.sum"
                >
                    <span class="ml-5 mr-2 amber--text"
                        ><b>Summary OT (Hrs.)</b></span
                    >
                    <v-btn-toggle rounded>
                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x10 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.0 :
                                    {{ data_main.sum.x10 }}
                                </v-btn>
                            </template>
                            <span>x1.0</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x15 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x1.5 :
                                    {{ data_main.sum.x15 }}
                                </v-btn>
                            </template>
                            <span>x1.5</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template
                                v-slot:activator="{
                                    on,
                                }"
                            >
                                <v-btn
                                    small
                                    v-on="on"
                                    :color="
                                        data_main.sum.x30 != 0
                                            ? 'green accent-3'
                                            : 'grey lighten-1'
                                    "
                                >
                                    x3.0 :
                                    {{ data_main.sum.x30 }}
                                </v-btn>
                            </template>
                            <span>x3.0</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-col>
                <hr />
            </v-row>

            <v-row v-for="(row, index) in data_main.detail" :key="index">
                <v-col cols="12" md="6">
                    <v-chip small class="ml-2" color="primary">{{
                        row.date + " - " + row.onsite_date_dw
                    }}</v-chip>

                    <v-chip
                        v-if="row.date_type == 'weekend'"
                        small
                        color="red accent-2"
                        class="ml-2 mr-2 "
                        >เสาร์อาทิตย์</v-chip
                    >
                    <v-chip
                        v-if="row.date_type == 'holiday'"
                        small
                        color="amber"
                        >วันหยุด</v-chip
                    >
                    <v-chip small class="ml-2 green accent-3">
                        {{ row.total_date }}
                    </v-chip>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="12" class="mar-t-30">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th class="text-center">
                                            Site
                                        </th>
                                        <th class="text-center">
                                            Case Title
                                        </th>
                                        <th class="text-center">
                                            Rate Overtime (Hrs.)
                                        </th>
                                        <!-- <th class="text-center">
                                            GPS
                                        </th> -->
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, i) in row.case" :key="i">
                                        <td>{{ i + 1 }}.</td>
                                        <td>
                                            <v-btn
                                                class="mt-1 mb-1 mr-1"
                                                :to="
                                                    '/Project/ViewCasepending/' +
                                                        team_name +
                                                        '/' +
                                                        r.maincase_id +
                                                        '/ViewDetail'
                                                "
                                                target="_blank"
                                                small
                                                color="white"
                                                rounded
                                                v-if="r.case_type"
                                            >
                                                <span class="mr-1 primary--text"
                                                    >{{
                                                        r.case_id +
                                                            "-" +
                                                            r.subcase
                                                    }}
                                                </span>

                                                <span class="teal--text">
                                                    {{ r.created_date }}</span
                                                >
                                            </v-btn>
                                            <v-chip
                                                small
                                                :color="
                                                    r.case_type == 'bench'
                                                        ? 'red lighten-1'
                                                        : ''
                                                "
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.case_type }}</v-chip
                                            >
                                            <v-chip
                                                small
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.project_name }}</v-chip
                                            >
                                            <v-chip
                                                class="mt-1 mb-1"
                                                small
                                                :color="r.colors"
                                                >{{ r.site_name }}</v-chip
                                            >
                                            <br />
                                            <span class="mr-1"
                                                ><b>{{
                                                    r.site_amphur_id
                                                }}</b></span
                                            >
                                            <span
                                                ><b>{{
                                                    r.site_province_id
                                                }}</b></span
                                            >

                                            <div v-if="site_address != null">
                                                <span
                                                    v-if="
                                                        r.site_address.length <
                                                            35
                                                    "
                                                    >{{ r.site_address }}</span
                                                >
                                                <span v-else>
                                                    {{
                                                        r.site_address.substring(
                                                            0,
                                                            35
                                                        ) + "..."
                                                    }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ r.case_title }} <br />
                                            <b>{{
                                                r.sub_status_name +
                                                    " - " +
                                                    r.solution
                                            }}</b>
                                            <v-chip
                                                small
                                                class="mb-1 ml-1"
                                                v-if="r.ship_date"
                                                >{{
                                                    "Ship : " +
                                                        r.ship_date +
                                                        " - " +
                                                        r.ship_date_dw
                                                }}
                                            </v-chip>

                                            <div v-if="r.cso.length > 0">
                                                <view-image
                                                    :title="
                                                        'CSO ( ' +
                                                            r.cso.length +
                                                            ' )'
                                                    "
                                                    :data="r.cso"
                                                />
                                            </div>
                                        </td>

                                        <td class="text-center">
                                            <p
                                                style="font-size:12px; font-weight: bold; color:#021640;"
                                            >
                                                {{
                                                    "เวลาทำงาน " +
                                                        r.service_time
                                                }}
                                            </p>
                                            <p
                                                style="font-size:12px; font-weight: bold; color:#415378;"
                                                class="mar-t-15"
                                                v-if="r.remark"
                                            >
                                                {{ r.remark }}
                                            </p>
                                            <p
                                                style="font-size:12px; font-weight: bold; "
                                                class="mar-t-15"
                                            >
                                                <span
                                                    style="color:#3F51B5;"
                                                    v-if="r.total_hr == '00'"
                                                    >{{
                                                        "คิดเป็น " +
                                                            r.total_duration +
                                                            " นาที"
                                                    }}</span
                                                >
                                                <span
                                                    style="color:#009688;"
                                                    v-else
                                                    >{{
                                                        "คิดเป็น " +
                                                            r.total_duration +
                                                            " ชั่วโมง"
                                                    }}</span
                                                >
                                            </p>
                                        </td>

                                        <td class="text-center">
                                            <v-switch
                                                v-model="checkboxs"
                                                :value="r.subcase_id"
                                                inset
                                                :disabled="
                                                    func_chk_approve(
                                                        chk_approve
                                                    ) == false
                                                "
                                                @change="
                                                    change_case(r.subcase_id)
                                                "
                                            ></v-switch>

                                            <v-btn
                                                x-small
                                                color="white"
                                                class="primary--text"
                                                fab
                                                v-if="r.ot_log.length > 0"
                                                @click="open_log(r.ot_log)"
                                            >
                                                <v-icon left class="ml-2"
                                                    >mdi-magnify</v-icon
                                                >
                                            </v-btn>

                                            <!-- @change="calculate(index, row.case)" -->
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-col>
            </v-row>
        </v-card>

        <v-row justify="center">
            <v-dialog
                v-model="dialogMap"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogMap = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <!-- <v-toolbar-title></v-toolbar-title> -->
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <TravelMap :data_map="data_map" />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row>
            <v-col cols="12" class="text-right">
                <v-btn
                    fab
                    fixed
                    align-self-end
                    bottom
                    small
                    style="z-index:100; margin-bottom: 80px; margin-left: -54px;"
                    @click="dialogLogGuide = true"
                >
                    <v-icon color="primary">mdi-help-circle-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogLogGuide" class="mx-auto" max-width="575">
            <img
                src="../../assets/all/guide_ot.png"
                alt="guide marker"
                width="100%"
            />
        </v-dialog>

        <v-dialog v-model="dialogLogOT" width="500">
            <OtLog :emp_id="emp_id" />
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-row justify="center">
            <v-dialog v-model="dialogFormLog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <!-- <span class="headline"></span> -->
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea
                                        v-model="key_logs.logs"
                                        outlined
                                        label="ระบุเหตุผล.."
                                        required
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="mar-t-40">
                        <v-spacer></v-spacer>
                        <!-- <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                        >
                            Close
                        </v-btn> -->
                        <v-btn color="blue darken-1" text @click="save_log()">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogLog" max-width="500px">
                <v-card>
                    <v-card-title class="subtitle-1 primary--text">
                        CHANGE LOG
                    </v-card-title>
                    <v-card-text>
                        <v-row v-for="(log, idx) in data_log" :key="idx">
                            <v-col cols="6">
                                <b
                                    >{{ log.log_date }}
                                    -
                                    {{ log.log_name }}
                                </b>
                            </v-col>
                            <v-col cols="6">
                                {{ log.log_note }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import TravelMap from "../Onsite/components/TravelMap2"
import Image from "../../components/ViewImage2"
import OtLog from "../Onsite/components/OTLog"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        "view-image": Image,
        TravelMap,
        OtLog,
    },
    beforeDestroy() {
        if (typeof window === "undefined") return

        window.removeEventListener("resize", this.onResize, { passive: true })
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        this.emp_id = this.$route.params.emp_id
    },
    mounted() {
        this.onResize()
        window.addEventListener("resize", this.onResize, { passive: true })
        this.get_data()
    },
    props: ["data_ScheduleCase"],
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),

        async get_data() {
            // this.mutateIsLoading()
            this.chk_load = true
            await axios
                .get(
                    url +
                        "ot-approve/view/" +
                        this.emp_id +
                        "/" +
                        this.$route.query.p,
                    this.tk
                )
                .then((response) => {
                    console.log(response)
                    // this.mutateIsLoading()
                    this.chk_load = false
                    // console.log(response.data, "-main data")
                    this.data_main = response.data
                    this.showbtn = response.data.showbtn
                    //chk_approve เอาไว้ดักเงื่อนไขเรื่อง save/approve
                    this.chk_approve =
                        response.data.approve_status.requested_status
                    this.text_show = response.data.approve_status.text_show
                    this.checkboxs = response.data.case
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        onResize() {
            this.isMobile = window.innerWidth < 600
        },
        get_MapAllDay(data) {
            // console.log(data)
            this.data_map = data
            this.dialogMap = true
        },
        save_approve(status) {
            this.form_save.status = status
            let send = {
                status: status,
                remark: this.form_save.remark,
                case: this.checkboxs,
                paycode: this.$route.query.p,
                logs: this.logs,
            }
            // console.log(send)
            let textx
            if (status === "approve") {
                textx = "Approve OT"
            } else {
                textx = "Not Approve OT"
            }

            this.$swal({
                title: "Are you sure ?",
                text: textx,
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.chk_approve_2 = true
                    axios
                        .post(
                            url + "ot-approve/update-status/" + this.emp_id,
                            send,
                            this.tk
                        )
                        .then((response) => {
                            this.menu = false
                            this.form_save.remark = ""

                            // this.chk_approve = response.data.requested_status
                            // this.data_paycode.approve_status =
                            //     response.data.requested_status
                            this.chk_approve_2 = false
                            this.mutatesnackbar()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        close_approve() {
            this.menu = false
            this.form_save.remark = ""
        },
        func_chk_approve(st) {
            if (this.role_name === "TL") {
                if (st === "request") {
                    return true
                } else {
                    return false
                }
            } else if (this.role_name === "Manager") {
                if (st === "head approve") {
                    return true
                } else {
                    return false
                }
            } else if (this.role_name === "Management") {
                if (st === "mgr approve") {
                    return true
                } else {
                    return false
                }
            }
        },
        async calculate(idx, cases) {
            this.chk_load = true
            let sendx = {
                checkboxs: this.checkboxs,
            }

            await axios
                .post(url + "ot/calculate/" + this.emp_id, sendx, this.tk)
                .then((response) => {
                    this.chk_load = false
                    this.chk_calculate = true
                    this.$set(this.data_main, "sum", response.data.sum)
                    this.$set(this.data_main, "detail", response.data.detail)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_case(subcase_id) {
            this.key_logs.subcase_id = subcase_id
            this.dialogFormLog = true
            this.chk_calculate = false
        },
        save_log() {
            if (
                this.logs.some((r) => r.subcase_id == this.key_logs.subcase_id)
            ) {
                const filterArray = this.logs.filter(
                    (item) => item.subcase_id !== this.key_logs.subcase_id
                )
                this.logs = filterArray
                this.logs.push(this.key_logs)
            } else {
                this.logs.push(this.key_logs)
            }

            this.key_logs = {
                subcase_id: "",
                logs: "",
            }
            this.dialogFormLog = false
        },
        open_log(logs) {
            this.data_log = logs
            this.dialogLog = true
        },
    },
    data() {
        return {
            chk_load: false,
            chk_calculate: true,
            chk_approve_2: false,
            tk: null,
            chk: {
                show: "",
                date: "",
                num: 0,
            },
            data_main: [],
            team_name: localStorage.team_name,
            isMobile: false,
            checkboxs: [],
            dialogMap: false,
            data_map: [],
            dialogLogGuide: false,
            emp_id: "",
            dialogLogOT: false,
            menu: false,
            form_save: {
                status: "",
                remark: "",
            },
            logs: [],
            key_logs: {
                subcase_id: "",
                logs: "",
            },
            chk_approve: null,
            text_show: "",
            showbtn: null,
            text: "Success, Your work has been saved",
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            form_query_paycode: this.$route.query.p,
            dialogFormLog: false,
            data_log: {},
            dialogLog: false,
        }
    },
}
</script>
`
